import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { accountReqSchema } from "~/entities/account";

import { Account } from "./Account";

export function createAccountRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "clients/$clientId/account",
    component: Account,
    validateSearch: accountReqSchema,
    head: () => ({
      meta: [{ title: "Account" }],
    }),
  });
}
